import { Fragment } from "react";
import type { UseFormMethods } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ICustomerDetailsForm } from "@features/customerDetails/ICustomerDetailsForm";
import { Address } from "@features/address/Address";
import { Grid, Typography } from "@mui/material";

interface IParams {
    formMethods: UseFormMethods<ICustomerDetailsForm>;
}

export const CustomerDetailsBillingAddress = (props: IParams) => {
    const { formMethods } = props;
    const { t } = useTranslation("customerDetails");

    return (
        <Fragment>
            <Grid container>
                <Grid item md={5} xs={12}>
                    <Typography color="secondary" marginBottom={2} variant="h4">
                        {t("billingAddress")}
                    </Typography>
                </Grid>
            </Grid>
            <Grid className="customer-form-fields" item xs={12}>
                <Address addressForm={formMethods} prefix="billingAddress" />
            </Grid>
        </Fragment>
    );
};
